// extracted by mini-css-extract-plugin
export default {"wrapper":"drawer_wrapper__DOQn5","drawerWrapper":"drawer_drawerWrapper__yp4i1","footer":"drawer_footer__HDi9x"};